var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.vars),function(varItem,index){return [(index > 0)?_c('hr',{key:`h-${varItem.id}`}):_vm._e(),_c('display-control',{key:`s-${varItem.id}`,attrs:{"component":varItem.component,"name":_vm.controlName(varItem),"show-label":true,"vars":[varItem]}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }